import * as datasetApis from './dataset';
import * as projectApis from './project';
export * from './customerApi';
const apis = {
    dataset: datasetApis,
    projects: projectApis
};
export default apis;
